import { ISystemIngredientFamily } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetIngredientFamiliesQuery<D extends ISystemIngredientFamily[]>(
  params?: HydraQueryParams<D>
) {
  const { vars, options } = params || {};
  return useHydraQuery<D>('getIngredientFamilies', '/api/ingredient_families', {
    vars,
    options,
  });
}
